import React from 'react';
import styles from './Component.module.css';

const Component = (props) => {
  const { icon } = props.type;
  const { title } = props.type;
  const { description } = props;

  let className = styles.Component;
  className = props.compact !== 'true' ? className : `${className} ${styles.Compact}`;
  className = props.larger !== 'true' ? className : `${className} ${styles.Larger}`;

  return (
    <div
      className={className}
      onDragStart={props.onDragStart}
      draggable={props.draggable}
    >
      <span className="icon">
        <i className={`fas fa fa-sm ${icon}`} />
      </span>
      {title}
      {description ? (
        <div className="description">
          {`   ${description}`}
        </div>
      ) : null}
    </div>
  );
};

export default Component;
